import ItemActividadResumenItem from "./ItemActividadResumenItem";
import ItemActividadResumenItemProps from "./ItemActividadResumenItemProps";

export default class ItemActividadResumen {
    title: string;
    items: ItemActividadResumenItem[];

    constructor(title: string, items: ItemActividadResumenItem[]) {
        this.title = title;
        this.items = items;
    };

    public static parse(json: any) : ItemActividadResumen[] {
        if (json) {
            return Object.keys(json).map((key: string) => {
                return new ItemActividadResumen(key, Object.keys(json[key]).map((key2: string) => {
                    return new ItemActividadResumenItem(key2, new ItemActividadResumenItemProps(json[key][key2]['valor'],
                        json[key][key2]['logoIcon'], json[key][key2]['backgroundColor'], json[key][key2]['color'],
                        json[key][key2]['descripcion']));
                }));
            });
        }
        else {
            return [];
        }
    };
};
